module.exports = __webpack_public_path__ + "static/media/Feedback_Breadcrumb.f393efa8.svg";